@if (minimumOrderValue) {
  @if (minimumOrderValue.shippingpercentage) {
    @if (minimumOrderValue.shippingpercentage !== 100) {
      <span>{{'mov.shipping_mov_percentage' |translate : { extraordervalue: minimumOrderValue.minimumtotalvalue - _calculatedPrice['priceincvatexshipping'] |currency: 'EUR':'symbol':'.2-2':'nl', percentage: minimumOrderValue.shippingpercentage } }}</span>
    }
    @if (minimumOrderValue.shippingpercentage === 100) {
      <span>{{'mov.shipping_mov_price_free' |translate : { extraordervalue: minimumOrderValue.minimumtotalvalue - _calculatedPrice['priceincvatexshipping'] |currency: 'EUR':'symbol':'.2-2':'nl'} }}</span>
    }
  } @else {
    @if (minimumOrderValue.shippingcost) {
      <span>{{'mov.shipping_mov_price' |translate : { extraordervalue: minimumOrderValue.minimumtotalvalue - _calculatedPrice['priceincvatexshipping'] |currency: 'EUR':'symbol':'.2-2':'nl', value: minimumOrderValue.shippingcost |currency: 'EUR':'symbol':'.2-2':'nl' } }}</span>
    }
    @if (!minimumOrderValue.shippingcost) {
      <span>{{'mov.shipping_mov_price_free' |translate : { extraordervalue: minimumOrderValue.minimumtotalvalue - _calculatedPrice['priceincvatexshipping'] |currency: 'EUR':'symbol':'.2-2':'nl'} }}</span>
    }
  }
}
